module.exports = __webpack_public_path__ + "img/title13.103e5c07.png";